exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".custom-cell-ellipsis {\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n}", ""]);

